import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CHAINS } from '../../constants';
import { useMrepState } from '../../helpers/mrepHelper';
import Logo from '../Logo/Logo';
import { Flexbox } from '../action/Flexbox';
import ThemeLogo from '../theme/ThemeLogo';
import ThemedText from '../theme/ThemedText';
import './BreadcrumbNavigator.scss';

const BreadcrumbNavigator = ({ isChain }) => {
  const [{ userData }] = useMrepState();
  const { userAddress } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const pathSegments = location.pathname
    .split('/')
    .filter(Boolean)
    .filter((item, index) => index > 1);

  const formatSegment = str => {
    const cleaned = str.replace(/[^a-zA-Z]/g, '');
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  };

  const handleNavigation = route => {
    const newPath = `/profile/${userAddress}/${route}`;
    navigate(newPath);
  };

  return (
    <Flexbox gap='0.75rem' fw justifyContent='flex-start' className='breadcrumb_wrapper'>
      <Flexbox gap='0.5rem' onClick={() => handleNavigation('projects')} className='pointer'>
        <Logo width={'1.5rem'} height={'1.5rem'} src={userData?.avatarUrl} borderRadius='50%' />
        <ThemedText.P>{userData?.name}`s Reputation</ThemedText.P>
      </Flexbox>
      <ThemeLogo icon={'blueArrow'} />
      {pathSegments.map((segment, index) => (
        <React.Fragment key={`breadcrumb_wrapper__active_${index}`}>
          <ThemedText.P
            className={index === pathSegments.length - 1 && 'breadcrumb_wrapper__active'}
            style={{
              cursor: 'pointer',
            }}
            onClick={() => handleNavigation(segment)}
          >
            {isChain && index === pathSegments.length - 1 ? formatSegment(CHAINS[segment].name) : formatSegment(segment)}
          </ThemedText.P>
          {index !== pathSegments.length - 1 && <ThemeLogo icon={'blueArrow'} />}
        </React.Fragment>
      ))}
    </Flexbox>
  );
};

export default BreadcrumbNavigator;
